import { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom";
import BreadCrumbs from '@components/Breadcrumbs'
import Button from '@components/Button'
import Icon from '@material-ui/core/Icon';
import Alert from '@material-ui/lab/Alert';
import Form from './Form';
import { apiClient } from '@services/api';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

const permissions = ['administrador'];

const Update = (props) => {
  document.title = `Editar detalhes da região - ${process.env.REACT_APP_NAME}`
  const { region_id } = useParams();
  const history = useHistory();
  const [region, setRegion] = useState({
    name: null,
    status: true,
  })
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  let url = `/regions/${region_id}`;

  const bradecrumbsConfig = [
    {
      title: 'Início',
      active: true,
      route: '/admin/regioes'
    },
    {
      title: `${region.name !== undefined ? region.name : ''}`,
      active: true,
      route: `/admin/regioes/detalhe/${region_id}`
    },
    {
      title: 'Edição',
    }
  ]

  const getregionById = url => {
    apiClient
      .httpInstance.get(url)
      .then(response => {
        if (response.status === 200) {
          setRegion(response.data);
          setIsEditing(true)
        }
      }
      );
  }

  const changeState = (ev) => {
    let value = ev.target.value;
    if (ev.target.name === "status") {
      value = ev.target.value === "true" ? true : false;
    }
    setRegion(
      {
        ...region,
        [ev.target.name]: value
      }
    )

  }

  const submitRegionEdit = (ev) => {
    ev.preventDefault();
    apiClient
      .httpInstance.put(`/regions/${region_id}`, {
        ...region,
        company_id: props.user.data.company_id
      })
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          history.push('/admin/regioes');
        }
      })
      .catch(error => {
        if (error) {
          setError(true);
          setErrorMessage(error.response.message || "Erro inesperado, tente novamente mais tarde")
          setTimeout(() => { setError(false) }, 4000);
        }
      });
  }

  useEffect(() => {
    getregionById(url);
  }, [url]);

  return <>
    <BreadCrumbs items={bradecrumbsConfig} />
    {isEditing &&
      <>
        {error && (
          <Alert className="mb-5" variant="filled" severity="error">
            {errorMessage}
          </Alert>
        )}
        {permissions.includes(props?.theme?.permission) ?
          <div className="px-7 pt-6">
            <div className="flex items-center justify-between mt-2 text-2xl text-blue">
              <span>Edição</span>
              <Button
                textcolor="#e8f0fb"
                padding="6px 15px"
                width="200"
                variant="outlined"
                onClick={() => history.push(`/admin/regioes/detalhe/${region_id}`)}
                bgColor="transparent"
              >
                <Icon className="mr-2">
                  arrow_back
                </Icon>
                Cancelar
              </Button>
            </div>
            <Form
              {...props}
              submit={submitRegionEdit}
              region={region}
              isEditing={isEditing}
              changeState={changeState}
            />
          </div>
          :
          <div className="px-7 pt-6">
            <div className="flex items-center justify-between mt-2 text-2xl text-blue">
              <span>Edição</span>
              <Button
                textcolor="#e8f0fb"
                padding="6px 15px"
                width="200"
                variant="outlined"
                onClick={() => history.push(`/admin/regioes/detalhe/${region_id}`)}
                bgColor="transparent"
              >
                <Icon className="mr-2">
                  arrow_back
                </Icon>
                Cancelar
              </Button>
            </div>
            <div className="mt-4 bg-white text-blue font-poppins" style={{ borderRadius: '10px' }}>
              Você não possui permissão para acessar este recurso.
            </div>
          </div>
        }
      </>
    }
  </>
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps
)(Update);
